import { createSlice } from "@reduxjs/toolkit";
import { getReconcilation } from "./actions/reconcilation";

const initialState = {
  reconcilation: null,
  total: 0,
  loading: false,
  pageState: { page: 1, pageSize: 50 },
};

export const reconcilationSlice = createSlice({
  name: "reconcilation",
  initialState,
  reducers: {
    setReconcilePage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.pageState = {
          ...state.pageState,
          page,
        };
      }
      if (pageSize) {
        state.pageState = {
          ...state.pageState,
          pageSize,
        };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReconcilation.pending, (state) => {
        state.loading = true;
      })
      .addCase(getReconcilation.fulfilled, (state, action) => {
        const { data, count } = action.payload;
        state.loading = false;
        state.reconcilation = data;
        state.total = count;
      })
      .addCase(getReconcilation.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setReconcilePage } = reconcilationSlice.actions;

export default reconcilationSlice.reducer;
